const _import = require('./_import_' + process.env.NODE_ENV)
import databases from '@/views/databases/databases'
import database from '@/views/databases/database'

const constantRouterMap = function constantRouterMap() {
    return [
    // 售货机
    {
        path: '/shj',
        name: 'shj',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/shj/wdshj',
        meta: { noCache: false, title: 'shj', icon: 'icon-shebeileifuwuqi' },
        children: [
            { path: 'wdshj', component: _import('shj/wdshj'), name: 'wdshj', meta: { noCache: false, title: 'wdshj', icon: 'example' } },
            { path: 'ztcx', component: _import('shj/ztcx'), name: 'ztcx', meta: { noCache: false, title: 'ztcx', icon: 'example' } },
            { path: 'jqbj', component: _import('shj/jqbj'), name: 'jqbj', meta: { noCache: false, title: 'jqbj', icon: 'example' } },
            { path: 'mbgl', component: _import('shj/mbgl/index'), name: 'mbgl', meta: { noCache: false, title: 'mbgl', icon: 'example' } },
            { path: 'shjMbadd', component: _import('shj/mbgl/components/shjMbsz'), name: 'shjMbadd', meta: { noCache: false, title: 'shjMbadd', icon: 'example' } },
            { path: 'shjMbset', component: _import('shj/mbgl/components/shjMbsz'), name: 'shjMbset', meta: { noCache: false, title: 'shjMbset', icon: 'example' } },
            { path: 'bywx', component: _import('shj/bywx'), name: 'bywx', meta: { noCache: false, title: 'bywx', icon: 'example' } },
            { path: 'jqxppz', component: _import('shj/jqxppz'), name: 'jqxppz', meta: { noCache: false, title: 'jqxppz', icon: 'example' } },
            { path: 'zdfx', component: _import('shj/zdfx/index'), name: 'zdfx', meta: { noCache: false, title: 'zdfx', icon: 'example' } },
            { path: 'dwgl', component: _import('shj/dwgl'), name: 'dwgl', meta: { noCache: false, title: 'dwgl', icon: 'example' } },
            { path: 'llk', component: _import('shj/llk'), name: 'llk', meta: { noCache: false, title: 'llk', icon: 'example' } },
        ]
    },
    //组织机构

    {
      path: '/zzjg',
      name: 'zzjg',
      component: resolve => require(['@/views/layout/Layout'], resolve),
      redirect: '/zzjg/tlsgl',
      meta: { noCache: false, title: 'zzjg', icon: 'icon-shebeileifuwuqi' },
      children: [
          { path: 'tlsgl', component: _import('zzjg/tlsgl'), name: 'tlsgl', meta: { noCache: false, title: 'tlsgl', icon: 'example' } },
          { path: 'yysgl', component: _import('zzjg/yysgl'), name: 'yysgl', meta: { noCache: false, title: 'yysgl', icon: 'example' } },


      ]
  },


    {
      	path: '/databases',
      	name: 'databases',
      	component: databases
    },
    {
      path: '/database',
      name: 'database',
      component: database
  },

    //库存盘点
    {
        path: '/kcpd',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "kcpd",
        redirect: '/kcpd/xlspkcpd',
        meta: { noCache: false, title: 'xlspkcpd', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'xlspkcpd', name: 'xlspkcpd', component: _import('kcpd/xlspkcpd'), meta: { noCache: false, title: 'xlspkcpd', icon: 'icon-yonghuguanli' } },
            { path: 'jqspkcpd', name: 'jqspkcpd', component: _import('kcpd/jqspkcpd'), meta: { noCache: false, title: 'jqspkcpd', icon: 'icon-yonghuguanli' } },
            { path: 'jqhdkcpd', name: 'jqhdkcpd', component: _import('kcpd/jqhdkcpd'), meta: { noCache: false, title: 'jqhdkcpd', icon: 'icon-yonghuguanli' } },
            { path: 'jqqhbjsz', name: 'jqqhbjsz', component: _import('kcpd/jqqhbjsz'), meta: { noCache: false, title: 'jqqhbjsz', icon: 'icon-yonghuguanli' } },
            { path: 'bhjl', name: 'bhjl', component: _import('kcpd/bhjl'), meta: { noCache: false, title: 'bhjl', icon: 'icon-yonghuguanli' } }
        ]
    },

    // 财富管理
    {
        path: '/cfgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "cfgl",
        redirect: '/cfgl/txgl',
        meta: { noCache: false, title: 'txgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'txgl', name: 'txgl', component: _import('cfgl/txgl'), meta: { noCache: false, title: 'txgl', icon: 'icon-yonghuguanli' } },
            { path: 'jyjsmx', name: 'jyjsmx', component: _import('cfgl/jyjsmx'), meta: { noCache: false, title: 'jyjsmx', icon: 'icon-yonghuguanli' } },
            { path: 'sksz', name: 'sksz', component: _import('cfgl/sksz'), meta: { noCache: false, title: 'sksz', icon: 'icon-yonghuguanli' } },
		    { path: 'wtddgl', name: 'wtddgl', component: _import('cfgl/wtddgl'), meta: { noCache: false, title: 'wtddgl', icon: 'icon-yonghuguanli' } },
		    { path: 'cfgl', name: 'cfgl', component: _import('cfgl/cfgl'), meta: { noCache: false, title: 'cfgl', icon: 'icon-yonghuguanli' } },
        ]
    },

    //交易管理
    {
        path: '/jygl',
        name: 'jygl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/jygl/tkgl',
        meta: { noCache: false, title: 'jygl', icon: 'icon-jiaoyi' },
        children: [
            { path: 'tkgl', name: 'tkgl', component: _import('jygl/tkgl'), meta: { noCache: false, title: 'tkgl', icon: 'example' } },
            { path: 'ddgl', name: 'ddgl', component: _import('jygl/ddgl'), meta: { noCache: false, title: 'ddgl', icon: 'example' } },
            { path: 'jqjymx', name: 'jqjymx', component: _import('jygl/jqjymx'), meta: { noCache: false, title: 'jqjymx', icon: 'example' } },
            { path: 'gk', name: 'gk', component: _import('jygl/gk'), meta: { noCache: false, title: 'gk', icon: 'example' } },
            { path: 'jyhz', name: 'jyhz', component: _import('jygl/jyhz'), meta: { noCache: false, title: 'jyhz', icon: 'example' } },
            { path: 'qhmgl', name: 'qhmgl', component: _import('jygl/qhmgl'), meta: { noCache: false, title: 'qhmgl', icon: 'example' } },
            { path: 'hgxq', name: 'hgxq', component: _import('jygl/ddgl/components/hgxq'), meta: { noCache: false, title: 'hgxq', icon: 'example' } },
            { path: 'zjtj', name: 'zjtj', component: _import('jygl/zjtj'), meta: { noCache: false, title: 'zjtj', icon: 'example' } }
        ]
    },
    //营销策划
    {
        path: '/yxch',
		name: 'yxch',
        component: resolve => require(['@/views/layout/Layout'], resolve),
		redirect: '/yxch/zkgl',
        meta: { noCache: false, title: 'yxch', icon: 'icon-huowujilu' },
        children: [
		        { path: 'yxfagl', name: 'yxfagl', component: _import('yxch/yxfagl'), meta: { noCache: false, title: 'yxfagl', icon: 'icon-yingxiao' } },
            { path: 'zkgl', name: 'zkgl', component: _import('yxch/zkgl'), meta: { noCache: false, title: 'zkgl', icon: 'icon-yingxiao' } },
            { path: 'yxjhgl', name: 'yxjhgl', component: _import('yxch/yxjhgl'), meta: { noCache: false, title: 'yxjhgl', icon: 'icon-yingxiao' } },
            { path: 'yhqgl', name: 'yhqgl', component: _import('yxch/yhqgl'), meta: { noCache: false, title: 'yhqgl', icon: 'icon-yingxiao' } },
            { path: 'yhqmx', name: 'yhqmx', component: _import('yxch/components/yhqmx'), meta: { noCache: false, title: 'yhqmx', icon: 'icon-yingxiao' } },
            { path: 'yhqmx', name: 'famc', component: _import('yxch/components/famc'), meta: { noCache: false, title: 'famc', icon: 'icon-yingxiao' } },
            { path: 'yhmmx', name: 'yhmmx', component: _import('yxch/components/yhmmx'), meta: { noCache: false, title: 'yhmmx', icon: 'icon-yingxiao' } },
            { path: 'yhmgl', name: 'yhmgl', component: _import('yxch/yhmgl'), meta: { noCache: false, title: 'yhmgl', icon: 'icon-yingxiao' } }
        ]
    },
    //进销存管理
    {
        path: '/jxcgl',
        name: 'jxcgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/jxcgl/wdgys',
        meta: { noCache: false, title: 'jxcgl', icon: 'icon-huowujilu' },
        children: [
            { path: 'wdgys', name: 'wdgys', component: _import('jxcgl/wdgys'), meta: { noCache: false, title: 'wdgys', icon: 'example' } },
            { path: 'gysspsz', name: 'gysspsz', component: _import('jxcgl/gysspsz'), meta: { noCache: false, title: 'gysspsz', icon: 'example' } },
            { path: 'ccgl', name: 'ccgl', component: _import('jxcgl/ccgl'), meta: { noCache: false, title: 'ccgl', icon: 'example' } },
            { path: 'cgjh', name: 'cgjh', component: _import('jxcgl/cgjh'), meta: { noCache: false, title: 'cgjh', icon: 'example' } },
            { path: 'cgd', name: 'cgd', component: _import('jxcgl/cgd'), meta: { noCache: false, title: 'cgd', icon: 'example' } },
            { path: 'rkdj', name: 'rkdj', component: _import('jxcgl/rkdj'), meta: { noCache: false, title: 'rkdj', icon: 'example' } },
            { path: 'sfk', name: 'sfk', component: _import('jxcgl/sfk'), meta: { noCache: false, title: 'sfk', icon: 'example' } },
            { path: 'chd', name: 'chd', component: _import('jxcgl/chd'), meta: { noCache: false, title: 'chd', icon: 'example' } },
            { path: 'bs', name: 'bs', component: _import('jxcgl/bs'), meta: { noCache: false, title: 'bs', icon: 'example' } },
            { path: 'bhd', name: 'bhd', component: _import('jxcgl/bhd'), meta: { noCache: false, title: 'bhd', icon: 'example' } },
        ]
    },
    //广告管理
    {
        path: '/gggl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        children: [{ path: 'cgggl', name: 'cgggl', component: _import('gggl/index'), meta: { noCache: false, title: 'gggl', icon: 'icon-guanggaoguanli' } }]
    },
    //会员管理
    {
        path: '/hygl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        children: [{ path: 'chygl', name: 'chygl', component: _import('hygl/index'), meta: { noCache: false, title: 'hygl', icon: 'icon-huiyuan1' } }]
    },
    //财务管理
    {
        path: '/cwgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "cwgl",
        redirect: '/cwgl/cwjs',
        meta: { noCache: false, title: 'cwgl', icon: 'icon-caiwuzhutifenxi' },
        children: [
            { path: 'cwjs', name: 'cwjs', component: _import('cwgl/cwjs'), meta: { noCache: false, title: 'cwjs', icon: 'icon-caiwuzhutifenxi' } },
            { path: 'jyjs', name: 'jyjs', component: _import('cwgl/jyjs'), meta: { noCache: false, title: 'jyjs', icon: 'icon-caiwuzhutifenxi' } }

        ]
    },
    //统计分析
    {
        path: '/tjfx',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "tjfx",
        redirect: '/tjfx/jqjytj',
        meta: { noCache: false, title: 'tjfx', icon: 'icon-caiwuzhutifenxi' },
        children: [
            { path: 'jqjytj', name: 'jqjytj', component: _import('tjfx/jqjytj'), meta: { noCache: false, title: 'jqjytj', icon: 'icon-caiwuzhutifenxi' } },
			{ path: 'spjytj', name: 'spjytj', component: _import('tjfx/spjytj'), meta: { noCache: false, title: 'spjytj', icon: 'icon-caiwuzhutifenxi' } },
            { path: 'zfjstj', name: 'zfjstj', component: _import('tjfx/zfjstj'), meta: { noCache: false, title: 'zfjstj', icon: 'icon-caiwuzhutifenxi' } },
			{ path: 'bbdc', name: 'bbdc', component: _import('tjfx/bbdc'), meta: { noCache: false, title: 'bbdc', icon: 'icon-caiwuzhutifenxi' } },
            { path: 'gmsptj', name: 'gmsptj', component: _import('tjfx/gmsptj'), meta: { noCache: false, title: 'gmsptj', icon: 'icon-caiwuzhutifenxi' } },
            { path: 'hgjltj', name: 'hgjltj', component: _import('tjfx/hgjltj'), meta: { noCache: false, title: 'hgjltj', icon: 'icon-caiwuzhutifenxi' } },
        ]
    },
    //商户管理
    {
        path: '/shgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "shgl",
        redirect: '/shgl/shjqsq',
        meta: { noCache: false, title: 'shgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'shjqsq', name: 'shjqsq', component: _import('shgl/shjqsq'), meta: { noCache: false, title: 'shjqsq', icon: 'icon-yonghuguanli' } },
            { path: 'wdsh', name: 'wdsh', component: _import('shgl/wdsh'), meta: { noCache: false, title: 'wdsh', icon: 'icon-yonghuguanli' } },
            { path: 'tdjqsq', name: 'tdjqsq', component: _import('shgl/tdjqsq'), meta: { noCache: false, title: 'tdjqsq', icon: 'icon-yonghuguanli' } },
            { path: 'wdtd', name: 'wdtd', component: _import('shgl/wdtd'), meta: { noCache: false, title: 'wdtd', icon: 'icon-yonghuguanli' } },
            { path: 'bjyh', component: _import('shgl/components/edit'), name: 'bjyh', meta: { title: 'bjyh', isEdit: true, noCache: false, } },
            { path: 'xzyh', component: _import('shgl/components/edit'), name: 'xzyh', meta: { title: 'xzyh', isEdit: false, noCache: false, } },
            { path: 'management', component: _import('shgl/components/management'), name: 'management', meta: { noCache: false, title: 'gljs' } },
            { path: 'wdys', name: 'wdys', component: _import('shgl/wdys'), meta: { noCache: false, title: 'wdys', icon: 'icon-yonghuguanli' } },
            { path: 'kfdh', name: 'kfdh', component: _import('shgl/kfdh'), meta: { noCache: false, title: 'kfdh', icon: 'icon-yonghuguanli' } },
        ]
    },
    //商品管理
    {
        path: '/spgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "spgl",
        redirect: '/spgl/wdsp',
        meta: { noCache: false, title: 'spgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'wdsp', name: 'wdsp', component: _import('spgl/wdsp'), meta: { noCache: false, title: 'wdsp', icon: 'icon-yonghuguanli' } },
			{ path: 'zksp', name: 'zksp', component: _import('spgl/zksp'), meta: { noCache: false, title: 'zksp', icon: 'icon-yonghuguanli' } },
			{ path: 'ypfl', name: 'ypfl', component: _import('spgl/ypfl'), meta: { noCache: false, title: 'ypfl', icon: 'icon-yonghuguanli' } },
			{ path: 'bqbkfl', name: 'bqbkfl', component: _import('spgl/bqbkfl'), meta: { noCache: false, title: 'bqbkfl', icon: 'icon-yonghuguanli' } },
			{ path: 'xzsp', name: 'xzsp', component: _import('spgl/xzsp'), meta: { noCache: false, title: 'xzsp', icon: 'icon-yonghuguanli' } },
			{ path: 'ptspk', name: 'ptspk', component: _import('spgl/ptspk'), meta: { noCache: false, title: 'ptspk', icon: 'icon-yonghuguanli' } },

        ]
    },
    //系统管理
    {
        path: '/xtgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/xtgl/zfsz/zffwgl',
        name: 'xtgl',
        meta: { title: 'xtgl', icon: 'example' },
        children: [{
                path: '/xtgl/zfsz',
                component: _import('xtgl/index'),
                redirect: '/xtgl/zfsz/zffwgl',
                name: 'zfsz',
                meta: { title: 'zfsz', icon: 'example' },
                children: [
                    { path: 'zffwgl', component: _import('xtgl/zfsz/zffwgl'), name: 'zffwgl', meta: { noCache: false, title: 'zffwgl', icon: 'example' } },
                    { path: 'fwscssz', component: _import('xtgl/zfsz/shzffwcssz'), name: 'shzffwcssz', meta: { noCache: false, title: 'shzffwcssz', icon: 'example' } },
                    { path: 'shzhsz', component: _import('xtgl/zfsz/zshcssz'), name: 'zshcssz', meta: { noCache: false, title: 'zshcssz', icon: 'example' } },
                    { path: 'rjs', component: _import('xtgl/zfsz/rjs'), name: 'rjs', meta: { noCache: false, title: 'rjs', icon: 'example' } },
                ]
            },
            {
                path: '/xtgl/dagl',
                component: _import('xtgl/index'),
                redirect: '/xtgl/dagl/zzgl',
                name: 'dagl',
                meta: { title: 'dagl', icon: 'example' },
                children: [
                    { path: 'zzgl', component: _import('xtgl/dagl/zzgl'), name: 'zzgl', meta: { noCache: false, title: 'zzgl', icon: 'example' } },
                ]
            },
            {
                path: '/xtgl/zygl',
                component: _import('xtgl/index'),
                redirect: '/xtgl/zygl/gngl',
                name: 'zygl',
                meta: { title: 'zygl', icon: 'example' },
                children: [
                    { path: 'gngl', component: _import('xtgl/zygl/gngl'), name: 'gngl', meta: { noCache: false, title: 'gngl', icon: 'example' } },
                    { path: 'cdgl', component: _import('xtgl/zygl/cdgl'), name: 'cdgl', meta: { noCache: false, title: 'cdgl', icon: 'example' } },
                    { path: 'xzptzy', component: _import('xtgl/zygl/component/edit'), name: 'xzptzy', meta: { noCache: false, isEdit: false, title: 'xzptzy', icon: 'example' } },
                    { path: 'bjptzy', component: _import('xtgl/zygl/component/edit'), name: 'bjptzy', meta: { noCache: false, isEdit: true, title: 'bjptzy', icon: 'example' } },
                ]
            },
            {
                path: '/xtgl/cqxgl',
                component: _import('xtgl/index'),
                redirect: '/xtgl/cqxgl/jsgl',
                name: 'cqxgl',
                meta: { title: 'qxgl', icon: 'example' },
                children: [
                    { path: 'jsgl', component: _import('xtgl/cqxgl/jsgl'), name: 'jsgl', meta: { noCache: false, title: 'jsgl', icon: 'example' } },
                    { path: 'xzjs', component: _import('xtgl/cqxgl/component/edit'), name: 'xzjs', meta: { noCache: false, isEdit: false, title: 'xzjs', icon: 'example' } },
                    { path: 'bjjs', component: _import('xtgl/cqxgl/component/edit'), name: 'bjjs', meta: { noCache: false, isEdit: true, title: 'bjjs', icon: 'example' } },
                    { path: 'jszyqx', component: _import('xtgl/cqxgl/component/resource'), name: 'jszyqx', meta: { noCache: false, isEdit: false, title: 'jszyqx', icon: 'example' } },
                ]
            },
            { path: '/xtgl/index', icon: 'example', component: _import('xtgl/index'), name: 'tab', meta: { title: 'xtgl' } },
            { path: '/xtgl/setpwd', icon: 'example', component: _import('xtgl/setpwd'), name: 'setpwd', meta: { title: 'setpwd' } },
			{ path: '/xtgl/rzgl', icon: 'example', component: _import('xtgl/rzgl'), name: 'rzgl', meta: { title: 'rzgl' } },
            { path: '/xtgl/sjzd', icon: 'example', component: _import('xtgl/sjzd'), name: 'sjzd', meta: { title: 'sjzd' } },
             { path: '/xtgl/shsjzd', icon: 'example', component: _import('xtgl/shsjzd'), name: 'shsjzd', meta: { title: 'shsjzd' } },
             { path: '/xtgl/sz', icon: 'example', component: _import('xtgl/sz'), name: 'sz', meta: { title: 'sz' } }
        ]
    },
	//会员管理
    {
        path: '/hygl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "hygl",
        redirect: '/hygl/wdhy',
        meta: { noCache: false, title: 'hygl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'wdhy', name: 'wdhy', component: _import('hygl/wdhy'), meta: { noCache: false, title: 'wdhy', icon: 'icon-yonghuguanli' } },
			{ path: 'wdhyk', name: 'wdhyk', component: _import('hygl/wdhyk'), meta: { noCache: false, title: 'wdhyk', icon: 'icon-yonghuguanli' } },
      		{ path: 'czmx', name: 'czmx', component: _import('hygl/czmx'), meta: { noCache: false, title: 'czmx', icon: 'icon-yonghuguanli' } },
       		{ path: 'sqbk', name: 'sqbk', component: _import('hygl/sqbk'), meta: { noCache: false, title: 'sqbk', icon: 'icon-yonghuguanli' } },
			{ path: 'yhsz', name: 'yhsz', component: _import('hygl/yhsz'), meta: { noCache: false, title: 'yhsz', icon: 'icon-yonghuguanli' } },
			{ path: 'hykrz', name: 'hykrz', component: _import('hygl/hykrz'), meta: { noCache: false, title: 'hykrz', icon: 'icon-yonghuguanli' } },
        ]
    },
	//药品管理
    {
        path: '/ypgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "ypgl",
        redirect: '/ypgl/yplb',
        meta: { noCache: false, title: 'ypgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'yplb', name: 'yplb', component: _import('ypgl/yplb'), meta: { noCache: false, title: 'yplb', icon: 'icon-yonghuguanli' } },
            { path: 'ypqx', name: 'ypqx', component: _import('ypgl/ypqx'), meta: { noCache: false, title: 'ypqx', icon: 'icon-yonghuguanli' } },
            { path: 'yppc', name: 'yppc', component: _import('ypgl/yppc'), meta: { noCache: false, title: 'yppc', icon: 'icon-yonghuguanli' } },
            { path: 'ypyh', name: 'ypyh', component: _import('ypgl/ypyh'), meta: { noCache: false, title: 'ypyh', icon: 'icon-yonghuguanli' } }
        ]
    },
    //登陆界面
    { path: '/login', component: _import('login/index'), hidden: true, },
    { path: '/ssologin', component: _import('ssologin/index'), hidden: true, },
    //主页
    {
        path: '',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: 'dashboard',
        children: [{ path: 'dashboard',component: _import('dashboard/index'),name: 'dashboard', meta: { title: 'sy', icon: 'sy', icon: 'icon-danweiguanli', noCache: true }},
        { path: 'syzfqq',component: _import('dashboard/syzfqq'),name: 'syzfqq', meta: { title: 'syzfqq', icon: 'syzfqq', icon: 'icon-danweiguanli', noCache: true }},
        { path: 'syspxlpm',component: _import('dashboard/syspxlpm'),name: 'syspxlpm', meta: { title: 'syspxlpm', icon: 'syzfqq', icon: 'icon-danweiguanli', noCache: true }},
        { path: 'syjqpm',component: _import('dashboard/syjqpm'),name: 'syjqpm', meta: { title: 'syjqpm', icon: 'syzfqq', icon: 'icon-danweiguanli', noCache: true }}

      ]
    },
    //经营分析
    {
        path: '/jyfx',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "jyfx",
        redirect: '/jyfx/mddh',
        meta: { noCache: false, title: 'jyfx', icon: 'icon-jiaoyimingxi' },
        children: [
            { path: 'mddh', name: 'mddh', component: _import('jyfx/mddh'), meta: { noCache: false, title: 'mddh', icon: 'icon-jiaoyimingxi' } },
            { path: 'mddhjs', name: 'mddhjs', component: _import('jyfx/mddhjs'), meta: { noCache: false, title: 'mddhjs', icon: 'icon-jiaoyimingxi' } },

        ]
    },
    //组织管理
    {
        path: '/zzgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "zzgl",
        redirect: '/zzgl/zzgl',
        meta: { noCache: false, title: 'zzgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'zzgl', name: 'zzgl', component: _import('zzgl/zzgl'), meta: { noCache: false, title: 'zzgl', icon: 'icon-yonghuguanli' } },
            { path: 'jsgl', name: 'jsgl', component: _import('zzgl/jsgl'), meta: { noCache: false, title: 'jsgl', icon: 'icon-yonghuguanli' } },
            { path: 'xzjs', component: _import('zzgl/component/edit'), name: 'xzjs', meta: { noCache: false, isEdit: false, title: 'xzjs', icon: 'example' } },
            { path: 'jszyqx', component: _import('zzgl/component/resource'), name: 'jszyqx', meta: { noCache: false, isEdit: false, title: 'jszyqx', icon: 'example' } },
            { path: 'glwdtd', name: 'glwdtd', component: _import('zzgl/glwdtd'), meta: { noCache: false, title: 'glwdtd', icon: 'icon-yonghuguanli' } },
            { path: 'glwdsh', name: 'glwdsh', component: _import('zzgl/glwdsh'), meta: { noCache: false, title: 'glwdsh', icon: 'icon-yonghuguanli' } },
            { path: 'gltdjqsq', name: 'gltdjqsq', component: _import('zzgl/gltdjqsq'), meta: { noCache: false, title: 'gltdjqsq', icon: 'icon-yonghuguanli' } },
            { path: 'glshjqsq', name: 'glshjqsq', component: _import('zzgl/glshjqsq'), meta: { noCache: false, title: 'glshjqsq', icon: 'icon-yonghuguanli' } },
             { path: 'bjyh', component: _import('zzgl/components/edit'), name: 'bjyh', meta: { title: 'bjyh', isEdit: true, noCache: false, } },
            { path: 'xzyh', component: _import('zzgl/components/edit'), name: 'xzyh', meta: { title: 'xzyh', isEdit: false, noCache: false, } },
            { path: 'management', component: _import('zzgl/components/management'), name: 'management', meta: { noCache: false, title: 'gljs' } },

        ]
    },
    //场所管理
    {
        path: '/csgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "csgl",
        redirect: '/csgl/csgl',
        meta: { noCache: false, title: 'csgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'csgl', name: 'csgl', component: _import('csgl/csgl'), meta: { noCache: false, title: 'csgl', icon: 'icon-yonghuguanli' } },

        ]
    },
    //我的商品
    {
        path: '/wdsp',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "wdsp",
        redirect: '/wdsp/shjsp',
        meta: { noCache: false, title: 'wdsp', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'shjsp', name: 'shjsp', component: _import('wdsp/shjsp'), meta: { noCache: false, title: 'shjsp', icon: 'icon-yonghuguanli' } },
		    { path: 'sck', name: 'sck', component: _import('wdsp/sck'), meta: { noCache: false, title: 'sck', icon: 'icon-yonghuguanli' } },
             { path: 'ypfl', name: 'spfl', component: _import('wdsp/ypfl'), meta: { noCache: false, title: 'spfl', icon: 'icon-yonghuguanli' } },
        ]
    },
    //角色管理
    {
        path: '/jsgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "jsgl",
        redirect: '/jsgl/jsgl',
        meta: { noCache: false, title: 'jsgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'jsgl', name: 'jsgl', component: _import('jsgl/jsgl'), meta: { noCache: false, title: 'jsgl', icon: 'icon-yonghuguanli' } },
            { path: 'xzjs', component: _import('jsgl/component/edit'), name: 'xzjs', meta: { noCache: false, isEdit: false, title: 'xzjs', icon: 'example' } },
            { path: 'jszyqx', component: _import('jsgl/component/resource'), name: 'jszyqx', meta: { noCache: false, isEdit: false, title: 'jszyqx', icon: 'example' } },
        ]
    },
    //App交易管理
    {
        path: '/gljygl',
        name: 'gljygl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/gljygl/glddgl',
        meta: { noCache: false, title: 'gljygl', icon: 'icon-jiaoyi' },
        children: [
            { path: 'glddgl', name: 'glddgl', component: _import('gljygl/glddgl'), meta: { noCache: false, title: 'glddgl', icon: 'example' } },
            { path: 'gltkgl', name: 'gltkgl', component: _import('gljygl/gltkgl'), meta: { noCache: false, title: 'gltkgl', icon: 'example' } },
            { path: 'glxxqh', name: 'glxxqh', component: _import('gljygl/glxxqh'), meta: { noCache: false, title: 'glxxqh', icon: 'example' } },
            { path: 'glzjtj', name: 'glzjtj', component: _import('gljygl/glzjtj'), meta: { noCache: false, title: 'glzjtj', icon: 'example' } },
            { path: 'spchjl', name: 'spchjl', component: _import('gljygl/spchjl'), meta: { noCache: false, title: 'spchjl', icon: 'example' } },
            { path: 'hgxq', name: 'hgxq', component: _import('gljygl/ddgl/components/hgxq'), meta: { noCache: false, title: 'hgxq', icon: 'example' } },
            { path: 'jqsptj', name: 'jqsptj', component: _import('gljygl/jqsptj'), meta: { noCache: false, title: 'jqsptj', icon: 'example' } }
        ]
    },
    // App售货机
    {
        path: '/glshj',
        name: 'glshj',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        redirect: '/glshj/glwddw',
        meta: { noCache: false, title: 'glshj', icon: 'icon-shebeileifuwuqi' },
        children: [
            { path: 'glwddw', component: _import('glshj/glwddw'), name: 'glwddw', meta: { noCache: false, title: 'glwddw', icon: 'example' } },
            { path: 'glwdshj', component: _import('glshj/glwdshj'), name: 'glwdshj', meta: { noCache: false, title: 'glwdshj', icon: 'example' } },
            { path: 'gljqzt', component: _import('glshj/gljqzt'), name: 'gljqzt', meta: { noCache: false, title: 'gljqzt', icon: 'example' } },
            { path: 'mbgl', component: _import('glshj/mbgl/index'), name: 'mbgl', meta: { noCache: false, title: 'mbgl', icon: 'example' } },
            { path: 'shjMbadd', component: _import('glshj/mbgl/components/shjMbsz'), name: 'shjMbadd', meta: { noCache: false, title: 'shjMbadd', icon: 'example' } },
            { path: 'shjMbset', component: _import('glshj/mbgl/components/shjMbsz'), name: 'shjMbset', meta: { noCache: false, title: 'shjMbset', icon: 'example' } },
            { path: 'zdfx', component: _import('glshj/zdfx/index'), name: 'zdfx', meta: { noCache: false, title: 'zdfx', icon: 'example' } },
            { path: 'jqbj', component: _import('glshj/jqbj'), name: 'jqbj', meta: { noCache: false, title: 'jqbj', icon: 'example' } }
        ]
    },
    // App财富管理
    {
        path: '/glcfgl',
        component: resolve => require(['@/views/layout/Layout'], resolve),
        name: "glcfgl",
        redirect: '/glcfgl/gltxgl',
        meta: { noCache: false, title: 'glcfgl', icon: 'icon-yonghuguanli' },
        children: [
            { path: 'gltxgl', name: 'gltxgl', component: _import('glcfgl/gltxgl'), meta: { noCache: false, title: 'gltxgl', icon: 'icon-yonghuguanli' } },
            { path: 'gljyjsmx', name: 'gljyjsmx', component: _import('glcfgl/gljyjsmx'), meta: { noCache: false, title: 'gljyjsmx', icon: 'icon-yonghuguanli' } },
            { path: 'glsksz', name: 'glsksz', component: _import('glcfgl/glsksz'), meta: { noCache: false, title: 'glsksz', icon: 'icon-yonghuguanli' } },
		    { path: 'wtddgl', name: 'wtddgl', component: _import('glcfgl/wtddgl'), meta: { noCache: false, title: 'wtddgl', icon: 'icon-yonghuguanli' } },
        { path: 'cfgl', name: 'cfgl', component: _import('cfgl/cfgl'), meta: { noCache: false, title: 'cfgl', icon: 'icon-yonghuguanli' } },
        { path: 'yxrb', name: 'yxrb', component: _import('glcfgl/yxrb'), meta: { noCache: false, title: 'yxrb', icon: 'icon-yonghuguanli' } },
        ]
    },

];
};

export default {
	constantRouterMap
}



// WEBPACK FOOTER //
// ./src/router/router.js